// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2715":"b8a11a98cbb6bfb5","4213":"3db1989b1a18ebe4","4731":"ae9683c1b53b658a","6272":"aa4472f7082b94cd"}[chunkId] + ".css";
};